import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";


export default class TransitionLines extends AbstractView {


	constructor($wrapper) {
		super();
		this.linesClass = 'transition-line';
		this.$wrapper = $wrapper;
		this.split = null;
		this.type = this.$wrapper[0].hasAttribute('data-transition-lines') ? this.$wrapper[0].getAttribute('data-transition-lines') : 'children';
		this.$targets = this.type === 'children' ? this.$wrapper[0].children : this.$wrapper[0];
		this.init();
	}

	initEl() {
		this.split = new SplitText(this.$targets, {
			type: 'lines',
			linesClass: this.linesClass
		});
		this.tw.stshow = ScrollTrigger.create({
			trigger: this.$wrapper,
			start: 'top 90%',
			onEnter: () => this.animateFromTop()
		});
		this.tw.sthide = ScrollTrigger.create({
			trigger: this.$wrapper,
			start: 'top bottom',
			onLeaveBack: () => this.hideElements()
		});
		this.hideElements();
	}

	animateFromTop() {
		gsap.fromTo(this.split.lines, {
			autoAlpha: 0,
			y: 50,
		}, {
			autoAlpha: 1,
			y: 0,
			duration: 0.3,
			stagger: 0.1,
			immediateRender: true
		});
	}

	hideElements() {
		gsap.set(this.split.lines, {autoAlpha: 0});
	}


	update() {
		this.split.split();
		this.hideElements();
	}

	bindEvents() {
		Screen.on(Screen.E.RESIZE, this.resize, this);
		super.bindEvents();
	}

	unbindEvents() {
		Screen.off(Screen.E.RESIZE, this.resize, this);
		super.bindEvents();
	}

	resize(isMobileH) {
		if (!isMobileH) {
			this.update();
		}
	}

	destroy() {
		this.split = null;
		super.destroy();
	}
}
